import {Component, NgZone, OnInit} from '@angular/core';
import {environment} from "../../../environments/environment";
import {
  CreateCompanyDialogComponent
} from "../../private/companies/create-company-dialog/create-company-dialog.component";
import {Company} from "../../model/company";
import {switchMap} from "rxjs/operators";
import {EMPTY, Observable} from "rxjs";
import {MatDialog} from "@angular/material/dialog";
import {SnackService} from "../../services/snack.service";
import {KeycloakService} from 'keycloak-angular';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {AuthService} from "../../services/auth.service";


@Component({
  selector: 'aw-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  appName?: string;
  isKeycloak: boolean;

  constructor(
    public dialog: MatDialog,
    public snackService: SnackService,
    public authService: AuthService,
    private keycloak: KeycloakService,
    private ngZone: NgZone,
    private http: HttpClient,
    private router: Router,
    private snackBar: MatSnackBar,
  ) {

    this.isKeycloak = environment.IDENTITY_PROVIDER == 'keycloak' ? true : false;
    this.appName = environment.appName;
    
  }


  ngOnInit(): void {
  }

  openCompanyRequestForm(): void {
    this.dialog
      .open(CreateCompanyDialogComponent, {data: {company: new Company(), isRegistrationRequest: true}})
      .afterClosed()
      .pipe(switchMap(value => value ? new Observable<void>() : EMPTY))
      .subscribe(
        () => {
          this.snackService.success("Company subscription correctly submitted!");
        },
        (error) => {
          this.snackService.error(error.message);
        }, () => {
        });

  }
}
